import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// import { menuItems } from './menuItems'
const Navbar = () => {
  const [menuData, setMenuData] = useState([]);
  const [activeLink, setActiveLink] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const navigate = useNavigate();
  const handleSearchChange = (e) => {
    setSearchValue(e.target.value);
  };

  const searchMapping = {
    "EOL test hardware setup": "/EOL-test-hardware-setup",
    DLM5000: "/DLM5000",
    DLM3000: "/DLM3000",
    DL950: "/DL950",
    DL350: "/DL350",
    WT5000: "/WT5000",
    "EOL-Testing": "/EOL-Testing",
    Oscilloscopes: "/Oscilloscopes",
    Accessories: "/Accessories",
    broadband_amplifier: "/broadband_amplifier",
    "EOL for DLDC coverter": "/EOL-for-DLDC-coverter",
    "EOL for off board charger": "/EOL-for-off-board-charger",
    "EOL for MCU": "/EOL-for-MCU",
    PLC: "/PLC",
    SCADA: "/SCADA",
    HMI: "/HMI",
    "control-system": "/control-system",
    "sensor&actuator": "/sensor&actuator",
    robotics: "/robotics",
    labview: "/labview",
    "HVAC Control system": "/HVAC-Control-system",
    "lighting control": "/lighting-control",
    "security system": "/security-system",
    "humidity stability chamber": "/humidity-stability-chamber",
    "laminar air flow": "/laminar-air-flow",
    "walking plant growth chamber": "/walking-plant-growth-chamber",
    "minus 60 deep freezer": "/minus-60-deep-freezer",
    "blast freezer": "/blast-freezer",
    "antistatic workbench": "/antistatic-workbench",
    "ESD PCB Rack": "/ESD-PCB-Rack",
    "ESD Safe Conveyor": "/ESD-Safe-Conveyor",
    "ESD Safe Bin": "/ESD-Safe-Bin",
    "Grounding Chord": "/Grounding-Chord",
    "ESD Safe Matting": "/ESD-Safe-Matting",
    "": "/",
    "": "/",
    "": "/",
    "": "/",
    "": "/",
  };

  const handleSearch = (e) => {
    e.preventDefault();
    const matchedUrl = Object.keys(searchMapping).find((key) =>
      searchValue.toLowerCase().includes(key.toLowerCase())
    );

    if (matchedUrl) {
      navigate(searchMapping[matchedUrl]);
    } else {
      alert("no results");
      console.log("No match found for:", searchValue);
    }
  };

  useEffect(() => {
    fetch("https://inmortaltechnologies.com/technociv-e-commerce/api/get-menu")
      .then((response) => response.json())
      .then((data) => {
        if (data.status) {
          setMenuData(data.data);
        }
      })
      .catch((error) => console.error("Error fetching menu data:", error));
  }, []);

  const handleLinkClick = (href) => {
    setActiveLink(href);
  };

  // const renderSubMenu = (subMenu) => {
  //     if (!Array.isArray(subMenu)) {
  //       subMenu = [];
  //     }
  //     return (
  //       <ul className="dropdown-menu">
  //         {subMenu.map((item, index) => {
  //         return(
  //           <li key={index} className={`menu-item ${item.child_menu && item.child_menu.length > 0 ? 'dropdown-submenu' : ''}`}>
  //             <a
  //               href={item.url || '#'}
  //               className={`nav-item nav-link ${item.child_menu && item.child_menu.length > 0 ? 'dropdown-toggle' : ''}`}
  //               onClick={() => handleLinkClick(item.url)}
  //             >
  //               {item.sub_menu} {item.child_menu && item.child_menu.length > 0 && <span className="caret"></span>}
  //             </a>
  //             {item.child_menu && renderSubMenu(item.child_menu)}
  //           </li>
  //          )
  //         })}
  //       </ul>
  //     );
  //   };

  const renderSubMenu = (subMenu) => {
    if (!Array.isArray(subMenu)) {
      return null;
    }

    return (
      <ul className="dropdown-menu">
        {subMenu.map((item, index) => (
          <li
            key={index}
            className={`menu-item ${item.child_menu && item.child_menu.length > 0
              ? "dropdown-submenu"
              : ""
              }`}
          >
            <a
              href={item.url || "#"}
              className={`nav-item nav-link ${item.child_menu && item.child_menu.length > 0
                ? "dropdown-toggle"
                : ""
                }`}
              onClick={() => handleLinkClick(item.url)}
            >
              {item.sub_menu}{" "}
              {item.child_menu && item.child_menu.length > 0 && (
                <i className="fa fa-caret-right submenu-icon"></i>
              )}
            </a>
            {item.child_menu &&
              item.child_menu.length > 0 &&
              renderChildMenu(item.child_menu)}
          </li>
        ))}
      </ul>
    );
  };

  const renderChildMenu = (childMenu) => {
    if (!Array.isArray(childMenu)) {
      return null;
    }

    return (
      <ul className="dropdown-menu">
        {childMenu.map((item, index) => (
          <li
            key={index}
            className={`menu-item ${item.sub_child_menu && item.sub_child_menu.length > 0
              ? "dropdown-submenu"
              : ""
              }`}
          >
            <a
              href={item.url || "#"}
              className={`nav-item nav-link ${item.sub_child_menu && item.sub_child_menu.length > 0
                ? "dropdown-toggle"
                : ""
                }`}
              onClick={() => handleLinkClick(item.url)}
            >
              {item.child_menu}{" "}
              {item.sub_child_menu && item.sub_child_menu.length > 0 && (
                <i className="fa fa-caret-right submenu-icon"></i>
              )}
            </a>
            {item.sub_child_menu &&
              item.sub_child_menu.length > 0 &&
              renderSubChildMenu(item.sub_child_menu)}
          </li>
        ))}
      </ul>
    );
  };

  const renderSubChildMenu = (subChildMenu) => {
    if (!Array.isArray(subChildMenu)) {
      return null;
    }

    return (
      <ul className="dropdown-menu">
        {subChildMenu.map((item, index) => (
          <li
            key={index}
            className={`menu-item ${item.sub_sub_child_menu && item.sub_sub_child_menu.length > 0
              ? "dropdown-submenu"
              : ""
              }`}
          >
            <a
              href={item.url || "#"}
              className={`nav-item nav-link ${item.sub_sub_child_menu && item.sub_sub_child_menu.length > 0
                ? "dropdown-toggle"
                : ""
                }`}
              onClick={() => handleLinkClick(item.url)}
            >
              {item.sub_child_menu}{" "}
              {item.sub_sub_child_menu &&
                item.sub_sub_child_menu.length > 0 && (
                  <i className="fa fa-caret-right submenu-icon"></i>
                )}
            </a>
            {item.sub_sub_child_menu &&
              item.sub_sub_child_menu.length > 0 &&
              renderSubSubChildMenu(item.sub_sub_child_menu)}
          </li>
        ))}
      </ul>
    );
  };

  const renderSubSubChildMenu = (subSubChildMenu) => {
    if (!Array.isArray(subSubChildMenu)) {
      return null;
    }

    return (
      <ul className="dropdown-menu">
        {subSubChildMenu.map((item, index) => (
          <li
            key={index}
            className={`menu-item ${item.sub_sub_child_menu && item.sub_sub_child_menu.length > 0
              ? "dropdown-submenu"
              : ""
              }`}
          >
            <a
              href={item.url || "#"}
              className="nav-item nav-link"
              onClick={() => handleLinkClick(item.url)}
            >
              {item.subsubchild_menu}
              {item.sub_sub_sub_child_menu &&
                item.sub_sub_sub_child_menu.length > 0 && (
                  <i className="fa fa-caret-right submenu-icon"></i>
                )}
            </a>
            {item.sub_sub_sub_child_menu &&
              item.sub_sub_sub_child_menu.length > 0 &&
              renderSubSubSubChildMenu(item.sub_sub_sub_child_menu)}
          </li>
        ))}
      </ul>
    );
  };

  const renderSubSubSubChildMenu = (subSubSubChildMenu) => {
    if (!Array.isArray(subSubSubChildMenu)) {
      return null;
    }

    return (
      <ul className="dropdown-menu">
        {subSubSubChildMenu.map((item, index) => (
          <li key={index} className="menu-item">
            <a
              href={item.url || "#"}
              className="nav-item nav-link"
              onClick={() => handleLinkClick(item.url)}
            >
              {item.sub_sub_sub_child_menu}
            </a>
          </li>
        ))}
      </ul>
    );
  };

  const renderMenuItems = () => {
    return menuData.map((item, index) => (
      <li
        key={index}
        className={`menu-item ${item.sub_menu && item.sub_menu.length > 0 ? "dropdown" : ""
          } ${activeLink === item.url ? "active" : ""}`}
        onMouseEnter={() =>
          item.sub_menu && item.sub_menu.length > 0 && setActiveLink(item.url)
        }
        onMouseLeave={() =>
          item.sub_menu && item.sub_menu.length > 0 && setActiveLink("")
        }
      >
        <a
          href={item.url || "/"}
          className={`nav-item nav-link ${item.sub_menu && item.sub_menu.length > 0 ? "dropdown-toggle" : ""
            }`}
          onClick={() => handleLinkClick(item.url)}
        >
          {item.menu}{" "}
          {item.sub_menu && item.sub_menu.length > 0 && (
            <span className="caret"></span>
          )}
        </a>
        {item.sub_menu &&
          item.sub_menu.length > 0 &&
          renderSubMenu(item.sub_menu)}
      </li>
    ));
  };

  return (
    <div>
      <div class="full_width hdr_top_bar">
        <div class="container">
          <div class="row">
            <div class="col-lg-6 col-md-8 col-sm-8 col-xs-12">
              <ul class="hdr_top_list">
                <li class="hdr_msg_icon">
                  B-39, First Floor, B Block, Sector 64, Noida, UP-201301
                </li>
                <li class="hdr_call_icon">
                  +91- 9999445570 / 9958020570 / +91120-4573907
                </li>
              </ul>
            </div>
            <div class="col-lg-6 col-md-4 col-sm-4 col-xs-12">
              <div class="hdr_social_icons">
                <a
                  href="mailto:info@technociv.com"
                  class="hvr-bounce-to-bottom"
                >
                  <i aria-hidden="true" class="fa fa-envelope"></i>
                </a>

                <a
                  href="https://www.facebook.com/share/mm64oGKFnqQnCUDG/?mibextid=qi2Omg"
                  class="hvr-bounce-to-bottom"
                >
                  <i aria-hidden="true" class="fa fa-facebook"></i>
                </a>
                <a
                  href="https://www.instagram.com/technociv_technologies?igsh=ZHI1MHRuemhyZXV5&amp;utm_source=qr"
                  class="hvr-bounce-to-bottom"
                >
                  <i aria-hidden="true" class="fa fa-instagram"></i>
                </a>

                <a
                  href="https://www.linkedin.com/company/technociv-
technologies/?lipi=urn%3Ali%3Apage%3Ad_flagship3_search_srp_all%3BW%2BiUJxShQZSQ%
2F2JgRJLZsA%3D%3D"
                  class="hvr-bounce-to-bottom"
                >
                  <i aria-hidden="true" class="fa fa-linkedin"></i>
                </a>

                <a
                  href="https://www.youtube.com/@TechnocivTechnologies"
                  class="hvr-bounce-to-bottom"
                >
                  <i aria-hidden="true" class="fa fa-youtube-play"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <header class="full_width variation_home_1">
        <div class="container">
          <div class="row m_zero">
            <div class="col-lg-7 col-md-8 col-sm-12 col-xs-12 mobile_lead_hdr">
              <ul class="hdr_lead_list">
                <li>
                  <span class="hdr_lead_txt">
                    TRANSFORMING IDEAS INTO RELIABLE SOLUTIONS
                  </span>
                </li>
                <li>
                  <span class="hdr_lead_txt">
                    Certified<p>ISO 9001:2009</p>
                  </span>
                </li>
              </ul>
            </div>
            <div class="col-lg-5 col-md-4 col-sm-12 col-xs-12 desktop_none">
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 logo">
                <a href="/">
                  {/* <img src="https://shtheme.net/demosd/metallex1/wp-content/themes/metallex/images/common_image/logo.png" alt="logo" class="img-responsive" /> */}
                  <img src="/img/logo1.png" width={250} />
                </a>
              </div>
              <button
                type="button"
                data-toggle="collapse"
                data-target="#navbar"
                aria-expanded="false"
                aria-controls="navbar"
                class="navbar-toggle collapsed"
              >
                <span class="sr-only">Toggle navigation</span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
              </button>
            </div>
            <div class="col-lg-7 col-md-8 col-sm-12 col-xs-12 desktop_lead_hdr">
              <ul class="hdr_lead_list">
                <li>
                  <span class="hdr_lead_txt">
                    TRANSFORMING IDEAS <br /> INTO RELIABLE SOLUTIONS
                  </span>
                </li>
                <li>
                  <span class="hdr_lead_txt">
                    Certified<p>ISO 9001:2009</p>
                  </span>
                </li>
              </ul>
              <div className="hdr_search">
                <form
                  role="search"
                  className="navbar-form navbar-left"
                  onSubmit={handleSearch}
                >
                  <input
                    type="text"
                    onChange={handleSearchChange} 
                    value={searchValue} 
                    placeholder="Search" 
                    className="form-control" 
                    name="s"
                    id="s"
                  />
                  <button type="submit" className="btn btn-default">
                    {/* Search */}
                  </button>
                </form>
              </div>
            </div>
          </div>
          <div className="nav_col stricky home_page_hader">
            <div className="container">
              <div className="full_width yellow_nav_bg">
                <div className="row m_zero">
                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 p_zero">
                    <nav
                      id="main-navigation-wrapper"
                      className="navbar navbar-default home_navbar"
                    >
                      <div className="thm-container">
                        <div className="navbar-header">
                          <div className="logo-menu">
                            {/* <img src="/img/techlogo" alt="logo" /> */}
                            <img src="/img/logo1.png" alt="logo" />
                          </div>
                          <button
                            type="button"
                            data-toggle="collapse"
                            data-target="#main-navigation"
                            aria-expanded="false"
                            className="navbar-toggle collapsed"
                          >
                            <span className="sr-only">Toggle navigation</span>
                            <span className="icon-bar"></span>
                            <span className="icon-bar"></span>
                            <span className="icon-bar"></span>
                          </button>
                        </div>
                        <div
                          className="collapse navbar-collapse"
                          id="main-navigation"
                        >
                          <ul className="nav navbar-nav">
                            {renderMenuItems()}
                          </ul>
                          <div className="quote_desktop">
                            <a
                              href="contactUs"
                              className="view-all hvr-bounce-to-right get_quote_btn"
                            >
                              Get quote
                            </a>
                          </div>
                          <div className="quote_mob">
                            <a
                              href="contactUs"
                              className="view-all hvr-bounce-to-right get_quote_btn get_quote_mob"
                            >
                              Get quote
                            </a>
                          </div>
                        </div>
                      </div>
                    </nav>
                  </div>
                  <div className="col-lg-3 col-md-3 col-sm-3 col-sm-12 quote_mob_none"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </div>
  );
};

export default Navbar;
